<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: Download
 * @Description: 互勾下载
 * @FilePath: \web_manage_globalf:\work\web\app-tikfriend_web\src\pages\content\Download.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-08-11 22:49:17
 * @LastEditors: syl
 * @LastEditTime: 2022-07-04 13:34:29
 * @example: 调用示例
-->
<template>
  <div class="main-x">
    <div v-if="isShowTip" class="tip-x">请点击右上角，通过浏览器打开</div>
    <div class="media-x" v-if="IsPC()">
      <img
        :src="
          require('@/assets/media_' + curEquip + curData.mainImgTitle + '.png')
        "
      />
    </div>
    <div class="content-x">
      <div class="info-x">
        <div class="slogan">
          <div class="slogan-title">
            <pre>{{ curData.title }}</pre>
          </div>
          <div class="slogan-subtitle">{{ curData.slogan }}</div>
        </div>
        <div class="down-x">
          <div class="qrcode">
            <img
              width="132px"
              :src="require('@/assets/' + curData.qrcodeImg)"
              :title="curData.compName"
              :alt="curData.compName"
            />
          </div>
          <div class="down-btn-x">
            <a
              :href="(systemIs64=='true'||curEquip=='pc')?curData.androidUrl:curData.androidUrl32"
              @click="downAndroid()"
              class="down-btn bg-green"
              title="Android"
              v-if="curSystem != 'iOS' || curSystem == 'other'"
            >
              <img
                src="@/assets/android@2x.png"
                class="icon icon_down"
                alt="iOS"
              /><span>Android 客户端</span>
            </a>
            <a
              :href="curData.iOSUrl"
              class="down-btn bg-blue"
              title="App Store"
              v-if="curSystem != 'Android' || curSystem == 'other'"
            >
              <img
                src="@/assets/apple@2x.png"
                class="icon icon_down"
                alt="android"
              /><span>iOS 客户端</span>
            </a>
            <a
              :href="curData.windowsUrl"
              class="down-btn bg-gray"
              title="Windows"
              v-if="isShowWindows && curSystem == 'other'"
            >
              <img
                src="@/assets/win@2x.png"
                class="icon icon_down"
                alt="windows"
              /><span>PC 客户端</span>
            </a>
          </div>
        </div>
      </div>
      <div class="media-x" v-if="!IsPC()">
        <img
          :src="
            require('@/assets/media_' +
              curEquip +
              curData.mainImgTitle +
              '.png')
          "
        />
      </div>

      <div class="des-x">
        <div
          class="des-item"
          v-for="(item, index) in curData.conetent"
          :key="index"
        >
          <span :class="'des-item-' + item.type">{{ item.descript }}</span>
        </div>
      </div>
    </div>
    <div class="tip-x" v-show="isShowTip">
      <div class="tip-main">
        <div class="tip-text">
          <h3>如何下载或打开互勾 APP？</h3>
          <h5>如需下载或打开互勾APP，请按以下示意图操作。</h5>
        </div>
        <div class="step-item">
          <img src="@/assets/step01@2x.png" alt="第一步 点击右上角[更多]图标" />
          <h5>第一步</h5>
          <h5>点击右上角[更多]图标</h5>
        </div>
        <div class="step-item">
          <img src="@/assets/step02@2x.png" alt="第二步 选择Safari打开" />
          <h5>第二步</h5>
          <h5>选择浏览器打开</h5>
        </div>
      </div>
      <div class="tip-bg"></div>
      <div class="tip-close" @click="closeTip">
        <img src="@/assets/tip-close.png" alt="关闭" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Download",
  props: {
    curData: {
      type: Object,
      default: () => {},
    },
    isShowWindows: {
      type: Boolean,
      default: false,
    },
    describeData: {
      typpe: String,
      default: "1",
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      curSystem: localStorage.getItem("curSystem"),
      systemIs64: localStorage.getItem("systemIs64"),
      curImg: "",
      curEquip: localStorage.getItem("curEquip"),
      isShowTip: false,
      // curData: {},
    };
  },
  watch: {
    describeData(n, o) {
      let currentindex = parseInt(n);
      this.curData = this.$api.Index_item[currentindex];
    },
  },
  created() {
    console.log("curData",this.curData)
    // let currentindex = parseInt(this.describeData) - 1;
    // this.curData = this.$api.Index_item[currentindex];
  },
  methods: {
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPod",
        "iPad",
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      console.log("=========>",Agents[v],flag)
      return flag;
    },
    downAndroid() {
      let that = this;
      var ua = navigator.userAgent;
      if (ua.indexOf("MicroMessenger") > -1) {
        that.isShowTip = true;
        return false;
      }
    },
    closeTip() {
      this.isShowTip = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-x {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #111216;
  color: rgba(255, 255, 255, 0.8);
}
.tip-text {
  width: 300px;
  margin: 0 auto;
  margin-top: 34px;
  margin-bottom: 30px;
}
.tip-text h3 {
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 10px;
}
.tip-text h5 {
  font-size: 16px;
  font-weight: 200;
  margin-bottom: 10px;
}
.step-item {
  width: 300px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.step-item img {
  width: 100%;
  margin-bottom: 5px;
}
.step-item h5 {
  margin-bottom: 5px;
  font-weight: 200;
  font-size: 16px;
}
.tip-bg {
  background: rgba(0, 0, 0, 0.9);
}
.tip-close {
  position: fixed;
  bottom: 20px;
  top: 10px;
  right: 10px;
  img {
    width: 20px;
    height: 20px;
  }
}
</style>
